import { c as _c } from "react/compiler-runtime";
import { format, getDay, isSameDay, isSameMonth, startOfMonth } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
;
import { useState } from "react";
import DateItems from "src/components/dateselector/DateItems";
import type IDateGroup from "src/components/dateselector/IDateGroup";
import SelectorWrapper from "src/components/selectorwrapper/SelectorWrapper";
import LeftArrowSvg from "src/components/svg/LeftArrowSvg";
import RightArrowSvg from "src/components/svg/RightArrowSvg";
import { useProgramDatesContext } from "src/lib/contexts/ContextTypes";
import styles from './DateSelector.module.css';
import { locale as locl } from "@locale";

//#region [Props]
type DateSelectorProps = {
  className?: string;
};
//#endregion

//#region [Component]
export default function DateSelector(t0) {
  const $ = _c(47);
  const selectedDateContext = useProgramDatesContext();
  const [chosenMonthIndex, setMonthIndex] = useState(null);
  if (!selectedDateContext.availableDates) {
    return null;
  }
  let T0;
  let groupedDates;
  let monthIndex;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== chosenMonthIndex || $[1] !== selectedDateContext) {
    groupedDates = groupDates(selectedDateContext.availableDates);
    monthIndex = chosenMonthIndex ?? Math.max(0, groupedDates.findIndex(gd => gd.dates.some(d => isSameDay(selectedDateContext.selectedDate, d))));
    T0 = SelectorWrapper;
    if ($[11] !== selectedDateContext) {
      t5 = () => selectedDateContext.setShowSelectDateDialog(false);
      $[11] = selectedDateContext;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t6 = "Velg dag";
    t3 = styles.SMonthWrapper;
    let t7;
    if ($[13] !== monthIndex) {
      t7 = () => setMonthIndex(monthIndex - 1);
      $[13] = monthIndex;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const t8 = monthIndex === 0;
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <LeftArrowSvg className={styles.SLeftArrowSvg} />;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    if ($[16] !== t7 || $[17] !== t8) {
      t4 = <button className={styles.SArrowButton} onClick={t7} disabled={t8} aria-label={locl.dateSelector.previousMonth}>{t9}</button>;
      $[16] = t7;
      $[17] = t8;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t1 = styles.SMonth;
    t2 = getMonthString(groupedDates[monthIndex]?.month);
    $[0] = chosenMonthIndex;
    $[1] = selectedDateContext;
    $[2] = T0;
    $[3] = groupedDates;
    $[4] = monthIndex;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[2];
    groupedDates = $[3];
    monthIndex = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== monthIndex) {
    t8 = () => setMonthIndex(monthIndex + 1);
    $[22] = monthIndex;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const t9 = monthIndex >= groupedDates.length - 1;
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <RightArrowSvg className={styles.SRightArrowSvg} />;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t8 || $[26] !== t9) {
    t11 = <button className={styles.SArrowButton} onClick={t8} disabled={t9} aria-label={locl.dateSelector.nextMonth}>{t10}</button>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t3 || $[30] !== t4 || $[31] !== t7) {
    t12 = <div className={t3}>{t4}{t7}{t11}</div>;
    $[28] = t11;
    $[29] = t3;
    $[30] = t4;
    $[31] = t7;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const t13 = groupedDates?.[monthIndex];
  let t14;
  if ($[33] !== selectedDateContext) {
    t14 = date => {
      selectedDateContext.setSelectedDate(date);
      selectedDateContext.setShowSelectDateDialog(false);
    };
    $[33] = selectedDateContext;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== selectedDateContext.selectedDate || $[36] !== t13 || $[37] !== t14) {
    t15 = <DateItems month={t13} changeDate={t14} selectedDate={selectedDateContext.selectedDate} />;
    $[35] = selectedDateContext.selectedDate;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t12 || $[40] !== t15) {
    t16 = <div>{t12}{t15}</div>;
    $[39] = t12;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== T0 || $[43] !== t16 || $[44] !== t5 || $[45] !== t6) {
    t17 = <T0 onClose={t5} heading={t6}>{t16}</T0>;
    $[42] = T0;
    $[43] = t16;
    $[44] = t5;
    $[45] = t6;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
}
//#endregion

//#region [Other]

function getMonthString(month: Date | undefined | null) {
  if (!month) return "";
  return format(month, "MMMM yyyy", {
    locale
  });
}
function getMonthFirstDay(month: Date) {
  const som = getDay(startOfMonth(month)) - 1;
  return som < 0 ? 6 : som;
}
function groupDates(dates: Date[] | null | undefined): IDateGroup[] {
  let prevDate: Date | null = null;
  let currMonth: IDateGroup | null = null;
  const groupedDates: IDateGroup[] = [];
  dates?.forEach(d => {
    if (!prevDate || !isSameMonth(d, prevDate)) {
      prevDate = d;
      currMonth = {
        month: d,
        dates: [d]
      };
      groupedDates.push(currMonth);
    } else {
      currMonth?.dates.push(d);
    }
  });
  return groupedDates;
}

//#endregion